<template>
  <div class="common-footer">
    <div class="logo_block">
      <div class="double-flex">
        <ShadowButton
          class="shadow-button pc"
          :text="t('会社概要')"
          :textLeft="true"
          @handleShadowBtnClick="goToPubUrl"
        />
        <ShadowButton
          class="shadow-button pc"
          :text="t('特定商取引法に基づく表記')"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('利用規約')"
          @handleShadowBtnClick="goToTermsOfService"
        />
        <ShadowButton
          class="shadow-button pc"
          :text="t('個人情報保護ポリシー')"
          @handleShadowBtnClick="goToPrivacyProtection"
        />
        <!-- <ShadowButton
          class="shadow-button sp"
          :text="t('特定商取引法')"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button sp"
          :text="t('個人情報保護')"
          @handleShadowBtnClick="goToPrivacyProtection"
        /> -->
        <ShadowButton
          class="shadow-button"
          :text="t('ご利用ガイド')"
          @handleShadowBtnClick="goToUserGuide"
        />
        <ShadowButton
          class="shadow-button"
          :text="t('お問い合わせ')"
          @handleShadowBtnClick="goContactUs"
        />
      </div>
      <div class="logo">
        <img src="/img/logo_pc.png">
      </div>
    </div>
    <div class="footer">
      Copyright © 2023 iranoan All rights reserved.
    </div>
      <!-- <div class="footer-button-area">
        <DoubleBorderBox
          class="footer-btn"
          iconClassName="fa-home-lg"
          text="トップ"
          @handleClickDoubleBorderBox="goToTop"
        />
        <DoubleBorderBox
          class="footer-btn"
          iconName="footer-user.png"
          :text="t('マイページ')"
          @handleClickDoubleBorderBox="goToMyPage"
        />
        <DoubleBorderBox
          class="footer-btn"
          iconName="footer-point.png"
          :text="t('ポイント購入')"
          @handleClickDoubleBorderBox="goToBuyPoint"
        />
        <DoubleBorderBox
          class="footer-btn"
          iconName="footer-history.png"
          :text="t('商品購入履歴')"
          @handleClickDoubleBorderBox="goToBuyProductHistory"
        />
      </div> -->
  </div>
</template>

<script>
// import DoubleBorderBox from '@/components/molecules/DoubleBorderBox.vue';
import ShadowButton from '@/components/molecules/ShadowButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CommonFooter',

  components: {
    // DoubleBorderBox,
    ShadowButton,
  },

  props: {
    currentUser: {
      type: Object,
    },
  },
  mixins: [t],

  methods: {
    goToLogin() {
      // ログインしていない場合、ログイン画面へ。routerのbeforeEachだとエラーが出る。（リダイレクトはされる）
      const query = {
        packId: this.$route.query.packId,
      };
      this.$router.push({
        path: '/login',
        query: this.$route.query.packId ? query : null,
      });
    },
    goToTop() {
      if (this.$route.name === 'Top') {
        return;
      }
      this.$router.push('/');
    },
    goToMyPage() {
      if (this.$route.name === 'MyPage') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      this.$router.push('/my-page');
    },
    goToBuyPoint() {
      if (this.$route.name === 'BuyPoint') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      let url = '/buy-point';
      if (this.$route.params.productId) {
        url += `/${this.$route.params.productId}`;
      }
      this.$router.push(url);
    },
    goToBuyProductHistory() {
      if (this.$route.name === 'BuyProductHistory') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      this.$router.push('/buy-product-history');
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToTermsOfService() {
      this.$router.push('/terms-of-service');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    goContactUs() {
      if (process.env.VUE_APP_LANG_MODE === 'jp') {
        window.open('https://www.iranoan.com/contacts', '_blank');
      } else {
        window.open('https://www.iranoan.com/contacts', '_blank');
      }
    },
    goToPubUrl() {
      window.open('https://iranoan.site/');
    },
  },
};
</script>

<style lang="scss" scoped>
.common-footer {
  background-color: $mainColor;
  .double-flex {
    padding: 20px;
    .shadow-button {
      margin: 5px 15px;
    }
  }
  .footer-button-area {
    display: none;
  }
  .logo_block {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    .logo {
      img {
        width: 180px;
      }
    }
  }
}
.footer {
  background-color: $mainColor;
  color: #fff;
  text-align: center;
  font-size: 12px;
  padding: 0 0 20px 0;
}
.pc {
  display: block;
}
.sp {
  display: none;
}
@media screen and (max-width: $tabletWidth) {
  .common-footer{
    .double-flex {
      padding: 20px 20px;
      .shadow-button {
        width: 100%;
        margin: 10px 0;
      }
    }
    .logo_block {
      .logo {
        img {
          width: 150px;
        }
      }
    }
  }
}
</style>
